import { useEffect, useState } from "react";
import { Timer, Trophy, Users } from "lucide-react";
import { fmtChips } from "../../lib/api";

const mmss = (ms) => { const s = Math.max(0, Math.ceil(ms / 1000)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`; };

// Tournament strip under the header: registering count → start countdown → level + next-level clock → final payouts.
export const SngBanner = ({ t, serverNow, myUserId }) => {
  const [, tick] = useState(0);
  useEffect(() => { const i = setInterval(() => tick((n) => n + 1), 1000); return () => clearInterval(i); }, []);
  const now = serverNow();
  const Pill = ({ children, testId }) => <span data-testid={testId} className="glass rounded-full px-3 py-1 text-xs flex items-center gap-1.5 text-amber-100">{children}</span>;
  return (
    <div data-testid="sng-banner" data-status={t.status} className="flex flex-col items-end gap-1.5 px-6 -mt-1 pb-1 z-10 pointer-events-none">
      {t.status === "REGISTERING" && <Pill testId="sng-registering"><Users className="w-3.5 h-3.5 text-emerald-300" /> Registering {t.registered}/{t.seats} — starts when full</Pill>}
      {t.status === "STARTING" && <Pill testId="sng-countdown"><Timer className="w-3.5 h-3.5 text-amber-300" /> Starting in {mmss(t.start_at - now)}</Pill>}
      {t.status === "RUNNING" && (
        <Pill testId="sng-level"><Timer className="w-3.5 h-3.5 text-emerald-300" /> Level {t.level} · blinds {t.sb}/{t.bb}{t.next_level ? ` · ${t.next_level.sb}/${t.next_level.bb} in ${mmss(t.next_level_at - now)}` : " · final level"} · {t.remaining} left</Pill>
      )}
      {t.status === "FINISHED" && (
        <Pill testId="sng-payouts"><Trophy className="w-3.5 h-3.5 text-amber-400" /> {t.payouts.map((p) => `${p.place === 1 ? "1st" : p.place === 2 ? "2nd" : `${p.place}rd`} ${p.name}${p.user_id === myUserId ? " (you)" : ""} ${fmtChips(p.amount)}`).join(" · ")} — next run opens shortly</Pill>
      )}
    </div>
  );
};
